var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorFilledreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.8261 10.3007-5.86468-9.7567c-.20467-.340667-.564-.544-.96133-.544-.39734 0-.75667.203333-.96067.543333l-5.865334 9.757367c-.2080003.346-.2133337.7786-.014667 1.13.198.3513.572.5693.976001.5693h11.72998c.4034 0 .778-.218.976-.5693.1987-.3514.1927-.784-.0153-1.13zm-6.15935-.3007h-1.33333v-1.33333h1.33333zm0-2.66667h-1.33333v-3.33333h1.33333z",
    fill: "currentColor"
  })));
}
export default SvgErrorFilledreact;